import React, { useEffect, useState } from 'react';
// import ChatWidget from '../component/ChatWidget/ChatWidget';
import Footer from '../component/Footer/FooterCommon';
import Navbar from '../component/Navbar/NavbarCommon';
import ArrowButton from '../component/Common/ArrowButton';
import { api } from '../api';
import { API_URL, ASSETS_URL } from '../utils/config';
import { toast } from 'react-toastify';
import moment from 'moment'
import { Link } from 'react-router-dom';
const NewsEvents = () => {
  const [events, setevents] = useState([])
  const [newsData, setnewsData] = useState([])
  const [heroContent, setHeroContent] = useState<{imageUrl:string; title:string} | null>(null)
  // const newsData = [
  //   {
  //     id: 1,
  //     date: { day: '29', month: 'Jun' },
  //     icon: '🎉',
  //     title: '150 Years Celebration',
  //     description: 'An engaging celebration was held at our company at Harahalli on.',
  //     date_first: '29 July 2024',
  //     type: 'news',
  //     actionText: 'View News'
  //   },
  //   {
  //     id: 2,
  //     date: { day: '10', month: 'Apr' },
  //     icon: '🌱',
  //     title: 'Sustainability Week',
  //     description: 'Hosted green initiatives across all plants.',
  //     type: 'news',
  //     actionText: 'View News'
  //   }
  // ];

  const eventsData = [
    {
      id: 1,
      date: { day: '29', month: 'Jun' },
      icon: (
        <img
          src="assets/india-flag.svg"
          alt="India Flag"
        />
      ),
      title: 'Republic Day Celebration',
      description: 'Join us for a flag hoisting & cultural program.',
      time: '10 AM - 1 PM',
      type: 'event',
      actionText: 'Know More'
    },
    {
      id: 2,
      date: { day: '8', month: 'Mar' },
      icon: '👩‍💼',
      title: "Women's Day Talk Show",
      description: 'Panel discussion and guest speaker session.',
      time: '10 AM - 1 PM',
      type: 'event',
      actionText: 'Know More'
    }
  ];
  useEffect(() => {
    fetchAllNewsAndEvents()
    fetchHeroContent()
  }, [])

  const fetchAllNewsAndEvents = async () => {
    const {data, error} = await api.get(`${API_URL.events}`)
    if (error) { toast.error(error.message); return }
    if (data) {
      const eventsAndNews = (data as any)?.data?.events
      setevents(eventsAndNews?.filter((item: any) => item.type === 'event'))
      setnewsData(eventsAndNews?.filter((item: any) => item.type === 'news'))
    }
  }

  const fetchHeroContent = async () => {
    const {data, error} = await api.get(`${API_URL.imageContent}?status=published&limit=1`)
    if (error || !data) return
    const first = (data as any)?.data?.imageContent?.[0]
    if (first) setHeroContent({ imageUrl: first.imageUrl, title: first.title })
  }
  

  return (
    <div className="min-h-screen bg-gray-50 font-poppins relative overflow-hidden">
      <Navbar />

      {/* Blue gradient effect at bottom */}
      <div className="fixed bottom-0 left-0 right-0 h-40 pointer-events-none z-0 ">
        <div className="w-full h-full bg-gradient-to-t from-blue-100/60 via-blue-50/40 to-transparent"></div>
      </div>

      {/* Main Content */}
       <div className="flex-grow py-4 lg:py-6 px-4 lg:px-10 mt-20 md:mt-2 lg:mt-28 xl:mt-28 font-poppins overflow-x-hidden ">
        <ArrowButton />
        {/* Header Section */}
        <div className="max-w-full mx-auto mb-8 sm:mb-12 md:mb-16 lg:mb-5 xl:mb-10 lg:mt-5 xl:mt-10">
          <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold text-green-600 mb-4">
            <span className='text-navgreen'>News </span>
            <span className='text-black'>& Events</span>
          </h1>
          <p className="text-sm md:text-base lg:text-lg text-deepTeal font-medium max-w-2xl">
            Stay updated with our latest achievements and celebrations.
          </p>
        </div>

        {/* Hero Image Section */}
        {heroContent && (
          <div className="max-w-full mx-auto mb-8 md:mb-7">
            <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl h-48 md:h-64 lg:h-80 xl:h-96">
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={`${ASSETS_URL}${heroContent.imageUrl}`}
                  alt={heroContent.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent"></div>

              {/* Bottom Blur Effect */}
              <div className="absolute bottom-0 left-0 right-0 h-24 md:h-32 lg:h-40">
                <div className="w-full h-full bg-gradient-to-t to-transparent"></div>
              </div>

              {/* Additional Blur Layer */}
              <div className="absolute bottom-0 left-0 right-0 h-16 md:h-20 lg:h-24">
                <div className="w-full h-full bg-gradient-to-t from-black/80 to-transparent via-white/40 backdrop-blur-[2.5px]"></div>
              </div>

              {/* Content — dynamic title from ImageContent */}
              <div className="absolute bottom-4 md:bottom-6 lg:bottom-8 left-4 md:left-6 lg:left-8 z-20">
                <span className="text-white text-lg md:text-xl lg:text-2xl font-semibold drop-shadow-lg">
                  {heroContent.title}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* News and Events Grid */}
        <div className="max-w-full mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-6 mb-16">

            {/* News Section */}
            <div>
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold text-deepTeal mb-4 sm:mb-6">
                News
              </h2>

              <div className="space-y-4 sm:space-y-6">
                {newsData?.map((item) => (
                  <div
                    key={item.id}
                    className="bg-white rounded-2xl sm:rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 w-full h-full sm:h-full flex flex-col"
                  >
                    <div className="flex gap-3 sm:gap-6 p-4 sm:p-6 h-full">
                      {/* Date */}
                      <div className="flex-shrink-0 text-center w-12 sm:w-16">
                        <div className="text-sm sm:text-lg md:text-xl font-medium text-black">
                          {moment( item?.eventDate).get('date')}
                        </div>
                        <div className="text-sm sm:text-lg md:text-xl font-medium text-black">
                        {moment( item?.eventDate).format('MMM')}
                        </div>
                      </div>

                      {/* Content */}
                      <div className="flex-1 flex flex-col justify-between h-full">
                        <div className="flex-1">
                          <div className="flex items-start gap-2 sm:gap-3 mb-2 sm:mb-3">
                            {/* <img className="text-lg sm:text-xl flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center" src={`${ASSETS_URL}${item?.imageUrl}`}/> */}
                            {/* <span >
                              {item.icon}
                            </span> */}
                            <h3 className="text-xs sm:text-lg md:text-xl font-semibold text-deepTeal leading-tight line-clamp-1">
                              {item.title}
                            </h3>
                          </div>
                          <div className="space-y-1">
                            <p className="text-xs sm:text-base md:text-lg text-deepTeal font-medium leading-relaxed line-clamp-2">
                              {item.description}
                            </p>
                            {/* {item.eventDate && (
                              <p className="text-xs sm:text-base md:text-lg text-deepTeal font-medium leading-relaxed">
                                {moment(item.eventDate).format('DD/MM/YYYY')}
                              </p>
                            )} */}
                          </div>
                        </div>
                        <div className="flex justify-end pt-2 sm:pt-4">
                        <Link to={`/news-events/${item._id}`}>
  <button className="flex items-center gap-1 sm:gap-2 text-black font-medium text-xs sm:text-base transition-colors group">
    <span>{item.actionText || "Read More"}</span>
    <img src="assets/arrow-assistant.svg" alt="arrow" className="w-3 h-3 sm:w-4 sm:h-4 group-hover:translate-x-1 transition-transform" />
  </button>
</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Events Section */}
            <div>
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold text-deepTeal mb-4 sm:mb-6">
                Events
              </h2>

              <div className="space-y-4 sm:space-y-6">
                {events?.map((item) => (
                  <div
                    key={item.id}
                    className="bg-white rounded-2xl sm:rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 w-full h-full sm:h-full flex flex-col"
                  >
                    <div className="flex gap-3 sm:gap-6 p-4 sm:p-6 h-full">
                      {/* Date */}
                    <div className="flex-shrink-0 text-center w-12 sm:w-16">
                        <div className="text-sm sm:text-lg md:text-xl font-medium text-black">
                          {moment( item?.eventDate).get('date')}
                        </div>
                        <div className="text-sm sm:text-lg md:text-xl font-medium text-black">
                        {moment( item?.eventDate).format('MMM')}
                        </div>
                
                      </div>

                      {/* Content */}
                      <div className="flex-1 flex flex-col justify-between h-full">
                        <div className="flex-1">
                          <div className="flex items-start gap-2 sm:gap-3 mb-2 sm:mb-3">
                            {/* <span className="text-lg sm:text-xl flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
                              {item.icon}
                            </span> */}
                            <h3 className="text-xs sm:text-lg md:text-xl font-semibold text-deepTeal leading-tight line-clamp-1">
                              {item.title}
                            </h3>
                          </div>
                          <div className="space-y-1">
                            <p className="text-xs sm:text-base md:text-lg text-deepTeal font-medium leading-relaxed line-clamp-2">
                            {item.description}
                            </p>
                            {/* {item.time && (
                              <p className="text-xs sm:text-base md:text-lg text-deepTeal font-medium leading-relaxed">
                                {item.time}
                              </p>
                            )} */}
                          </div>
                        </div>
                        <div className="flex justify-end pt-2 sm:pt-4">
                        <Link to={`/news-events/${item._id}`}>
  <button className="flex items-center gap-1 sm:gap-2 text-black font-medium text-xs sm:text-base transition-colors group">
    <span>{item.actionText || "Read More"}</span>
    <img src="assets/arrow-assistant.svg" alt="arrow" className="w-3 h-3 sm:w-4 sm:h-4 group-hover:translate-x-1 transition-transform" />
  </button>
</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Chat Widget */}
      {/* <ChatWidget /> */}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default NewsEvents;